module.exports = __webpack_public_path__ + "static/media/HR_Macbook.4865bb44.png";